// Renewal-mode controls for PermissionRequest.jsx (#5 chip, #6 back button).
import React from 'react';

// Read-only "Rebaseline of PAM-X" chip. The link is a plain <a> so the page fully reloads with clean state.
export const RenewalChip = ({ originalRequestId, listed }) => (
    <div style={{ padding: '10px 14px', borderRadius: '8px', background: '#eef6ff', border: '1px solid #b8d4f0', marginBottom: '8px', fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontWeight: '600', color: '#0073bb' }}>🔄 {listed ? 'Rebaseline' : 'Renewal'} of {originalRequestId}</span>
        <a href="/request/individual" style={{ fontSize: '12px', color: '#0073bb', textDecoration: 'underline' }}>Not this request? Start a new request</a>
    </div>
);

export const RenewalBackToTeam = ({ onClick }) => (
    <button type="button" onClick={onClick}
        style={{ padding: '10px 18px', borderRadius: '6px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', border: '2px solid #0073bb', background: '#f0f8ff', color: '#0073bb', marginBottom: '16px' }}>
        ← Back to Team
    </button>
);
